import { Email, Area, GreenTick, StepCheck, WhiteBed, WhiteMapPin, WhitePhone, WhitePrint } from 'assets/images/web-isn';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useHistory, useParams } from 'react-router';
import { formatMoney, formatterUSD } from 'utils/objects';
import CancelBookingComponent from '../common/cancelBooking.component';
import { handleDateLocale } from '../common/formatDate';
import { getBooking } from '../payment.api';
import { getQueryString } from 'utils/params';
import { addDays, parseISO, subDays } from 'date-fns';
import { getContactByType } from 'modules/helpPage/helps.api';
import { LoginComponent } from '../../loginPage/pages';
import ForgotModal from '../../../modules/forgotPassword/pages/ForgotModal.component';
import { VerifyEmailComponent } from '../../signUp/pages';
import { LockAccess } from '../../LockAccess';

// Step
const Step = props => {
  const newPageIndex = parseInt(props.pageIndex);

  // if (newPageIndex > 3) return;
  return (
    <div className="Stepper__step-3">
      <div className="Stepper__indicator">
        <span
          className={`${
            newPageIndex === props.indicator
              ? 'Stepper__info'
              : newPageIndex > props.indicator
              ? 'Stepper__info Stepper__info--img'
              : 'Stepper__info--not-active'
          }`}
        >
          {newPageIndex > props.indicator ? <img src={StepCheck} alt="step-checker" /> : props.indicator}
        </span>
      </div>
      <div
        className={`${
          newPageIndex === props.indicator || newPageIndex > props.indicator
            ? 'Stepper__label'
            : 'Stepper__label--not-active'
        }`}
      >
        {props.title}
      </div>
    </div>
  );
};
// Overlay
const Stepper = props => <div className="Stepper">{props.children}</div>;

function StepThreeComponent(props) {
  const { t } = useTranslation();
  const { bookingNumber } = useParams();
  const [bookingConfirmData, setBookingConfirmData] = useState({});
  const { currentCurrency } = props.layout;
  const history = useHistory();
  const { language } = useParams();
  const [showCancel, setShowCancel] = useState(false);
  const startDate = bookingConfirmData?.detailsBookingViewModel?.checkinDate;
  const endDate = bookingConfirmData?.detailsBookingViewModel?.checkoutDate;
  const [night, setNight] = useState(0);
  const [statusDesc, setStatusDesc] = useState('');
  const bookingStatus = bookingConfirmData?.detailsBookingViewModel?.bookingStatusId;
  const [equalCheckin, setEqualCheckin] = useState(false);
  const [contact, setContact] = useState({});
  const [showLogin, setShowLogin] = useState(false);
  const [showForgot, setShowForgot] = useState(false);
  const [showVerifyPopup, setShowVerifyPopup] = useState(false);
  const [allowAccess, setAllowAccess] = useState(true);
  // const today = new Date();

  const handleLockAccess = () => {
    setAllowAccess(false);
  };

  const handleShowLogin = () => {
    setShowLogin(true);
    setShowForgot(false);
  };

  const handleShowForgot = () => {
    setShowLogin(false);
    setShowForgot(true);
  };

  const handleShowSignUp = () => {
    setShowLogin(false);
    setShowVerifyPopup(true);
  };
  const closeVerifyEmailPopup = () => {
    setShowVerifyPopup(false);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });

    getBooking(getQueryString({ language, bookingNumber }))
    .then(res => {
      if (res.detailsBookingViewModel === null) {
        handleLockAccess();
        const authUserData = JSON.parse(localStorage.getItem('authUserData'));
        if(!authUserData){
          handleShowLogin();
        }
      }
      if (res) {
        setBookingConfirmData(res);
        getContactByType(
          getQueryString({ cityId: res?.detailsApartment?.cityId, language: language, type: 3 }),
        ).then(res => {
          if (res) {
            setContact(res[0] ?? {});
          }
        });
        if (bookingStatus === 1) {
          setStatusDesc(t('payment.label_bookingStatusDesc_1'));
        } else if (bookingStatus === 2) {
          setStatusDesc(t('payment.label_bookingStatusDesc_2'));
        } else if (bookingStatus === 4) {
          setStatusDesc(t('payment.label_bookingStatusDesc_3'));
        } else if (bookingStatus === 3) {
          setStatusDesc(t('payment.label_bookingStatusDesc_4'));
        } else if (bookingStatus === 5) {
          setStatusDesc(t('payment.label_bookingStatusDesc_5'));
        } else if (bookingStatus === 6) {
          setStatusDesc(t('payment.label_bookingStatusDesc_6'));
        } else {
          setStatusDesc('');
        }
      }
    })
    .catch(errorCode => {
      if (errorCode === 401) {
        handleLockAccess();
        const authUserData = JSON.parse(localStorage.getItem('authUserData'));
        if(!authUserData){
          handleShowLogin();
        }
      }
    });
    //eslint-disable-next-line
  }, [bookingStatus]);

  useEffect(() => {
    let difference = parseISO(endDate).getTime() - parseISO(startDate).getTime();
    let days = Math.round(difference / (1000 * 60 * 60 * 24));
    if (!isNaN(days)) {
      setNight(days);
    }

    if (
      moment(startDate).format('L') === moment(new Date()).format('L') ||
      moment(startDate).format('L') === moment(addDays(new Date(), 1)).format('L')
    ) {
      setEqualCheckin(true);
    } else {
      setEqualCheckin(false);
    }
  }, [startDate, endDate]);

  const handleGoHome = e => {
    e.preventDefault();
    history.push(`/${language}/`);
  };

  return (
    <div id="paymentPage" className="container">
      {!showLogin && !showForgot && !showVerifyPopup && !allowAccess? (<LockAccess/>):('')}
      {!showLogin && !showForgot && !showVerifyPopup && allowAccess? (
      <div className="payment-page">
        {/* Step */}
        <div className="row mx-0 no-printme">
          <Stepper>
            <Step pageIndex={1} indicator={1} title={t('payment.label_sumary')}></Step>
            <Step pageIndex={2} indicator={2} title={t('payment.label_paymentDetail')}></Step>
            <Step pageIndex={3} indicator={3} title={t('payment.label_confirmation')}></Step>
          </Stepper>
        </div>

        <div className="confirmation-page">
          <div className="confirmation-page__header">
            <p className="confirmation-page__company-name">{t('payment.company_name')}</p>
            <p className="confirmation-page__hotline">
              {t('payment.lable_hotline')}: <a href={`tel: ${contact?.phone}`}>{contact?.phone}</a>
            </p>
            <p className="confirmation-page__email">
              {t('payment.lable_email')}: <a href={`tel: ${contact?.emailSupport}`}>{contact?.emailSupport}</a>
            </p>
          </div>
          <div className="confirmation-page__header2">
            <div className="confirmation-page__title">{t('payment.label_bookingConfirmation')}</div>
            <div>{statusDesc}</div>
          </div>
          <div className="confirmation-page__booking-detail">
            <div className="confirmation-page__booking-detail_title">{t('payment.label_bookingDetail')}</div>
            <div className="confirmation-page__booking-detail_table printme">
              <div className="row mx-0 d-block d-lg-flex">
                <div className="col-12 col-lg-3 confirmation-page__booking-detail_table--left-contents">
                  <img
                    className="confirmation-page__booking-detail_table--img"
                    src={`${process.env.REACT_APP_ISN_IMAGE_URL}${bookingConfirmData?.detailsApartment?.images[0].url}`}
                    alt=""
                  />
                  <div className="confirmation-page__booking-detail_table--apartment-name">
                    {bookingConfirmData?.detailsApartment?.name}
                  </div>
                  <div className="confirmation-page__booking-detail_table--location">
                    <div>
                      <img src={WhiteMapPin} alt="map-pin" />
                    </div>
                    <div className="confirmation-page__booking-detail_table--location_right">
                      <div className="confirmation-page__booking-detail_table--location_address">
                        {bookingConfirmData?.detailsApartment?.address}
                      </div>
                      <div
                        onClick={() =>
                          history.push(
                            `/${language}/serviced-apartments/location/${bookingConfirmData?.detailsApartment?.commonId}/${bookingConfirmData?.detailsApartment?.slug}/short`,
                          )
                        }
                        className="confirmation-page__booking-detail_table--location_viewmap"
                      >
                        {t('payment.label_viewOnMap')}
                      </div>
                    </div>
                  </div>
                  <div className="confirmation-page__booking-detail_table--hotline">
                    <img src={WhitePhone} alt="phone" />
                    <a href={`tel: ${contact?.phone}`}>{contact?.phone}</a>
                  </div>
                  <div className="confirmation-page__booking-detail_table--hotline">
                    <img src={Email} alt="phone" />
                    <a href={`mailto: ${contact?.emailSupport}`}>{contact?.emailSupport}</a>
                  </div>
                  <div className="confirmation-page__booking-detail_table--bedrooms">
                    <img src={WhiteBed} alt="bed" />
                    {bookingConfirmData?.detailsApartment?.bedRoomName}
                  </div>
                  <div className="d-flex confirmation-page__booking-detail_table--area">
                    <img className="area" src={Area} alt="Area" />
                    <span className="d-flex">
                      {bookingConfirmData?.detailsApartment?.size}m<sup style={{ top: '4px' }}>2</sup>
                    </span>
                  </div>
                  <div
                    className="confirmation-page__booking-detail_table--print no-printme"
                    onClick={() => window.print()}
                  >
                    <img className="area" src={WhitePrint} alt="print" />
                    {t('payment.label_printConfirmationn')}
                  </div>
                  <div
                    onClick={() => {
                      history.push(`/${language}/list-booking`);
                    }}
                    className="confirmation-page__booking-detail_table--manage-booking no-printme"
                  >
                    {t('payment.label_manageYourBooking')}
                  </div>
                </div>
                <div className="col-12 col-lg-9 confirmation-page__booking-detail_table--right-contents">
                  {/* 1 */}
                  <div className="d-flex confirmation-page__booking-detail_table--border-bottom confirmation-page__booking-detail_table--ptb-18">
                    <div className="col-3 pl-0 payment-details__font-bold">{t('payment.label_bookingNumber')}</div>
                    <div className="col-9 pr-0 font-blue">
                      {bookingConfirmData?.detailsBookingViewModel?.bookingNumber}
                    </div>
                  </div>

                  {/* 2 */}
                  <div className="d-flex confirmation-page__booking-detail_table--border-bottom confirmation-page__booking-detail_table--ptb-18">
                    <div className="col-3 pl-0 payment-details__font-bold">
                      <div>{t('payment.label_checkIn')}</div>
                      <div>{t('payment.label_checkOut')}</div>
                      <div>{t('payment.label_night')}</div>
                    </div>
                    <div className="col-9 pr-0">
                      <div>
                        {handleDateLocale(bookingConfirmData?.detailsBookingViewModel?.checkinDate)}{' '}
                        <span className="time-check-in-out">(14:00 GMT+7)</span>
                      </div>
                      <div>
                        {handleDateLocale(bookingConfirmData?.detailsBookingViewModel?.checkoutDate)}{' '}
                        <span className="time-check-in-out">(12:00 GMT+7)</span>
                      </div>
                      <div className="font-green_normal">
                        {night} {night > 1 ? t('payment.label_nightsN') : t('payment.label_nightN')}
                      </div>
                    </div>
                  </div>

                  {/* 3 */}
                  <div className="d-flex confirmation-page__booking-detail_table--border-bottom confirmation-page__booking-detail_table--ptb-18">
                    <div className="col-3 pl-0 payment-details__font-bold">{t('payment.label_bookingStatus')}</div>
                    <div className="col-9 pr-0 font-red">
                      {bookingConfirmData?.detailsBookingViewModel?.bookingStatusName}{' '}
                    </div>
                  </div>

                  {/* 4 */}
                  <div className="d-flex confirmation-page__booking-detail_table--border-bottom confirmation-page__booking-detail_table--ptb-18">
                    <div className="col-3 pl-0 payment-details__font-bold">{t('payment.label_contactDetails')}</div>
                    <div className="col-9 pr-0">
                      <div className="text-break">{bookingConfirmData?.detailsBookingViewModel?.fullName}</div>
                      <div className="font-blue text-break">{bookingConfirmData?.detailsBookingViewModel?.email}</div>
                      <div>{bookingConfirmData?.detailsBookingViewModel?.phoneNumber}</div>
                    </div>
                  </div>

                  {/* 5 */}
                  <div className="d-flex confirmation-page__booking-detail_table--border-bottom confirmation-page__booking-detail_table--ptb-18">
                    <div className="col-3 pl-0 payment-details__font-bold">{t('payment.label_price')}</div>
                    <div className="col-9 pr-0">
                      <div className="d-flex justify-content-between">
                        <div>
                          {formatMoney(
                            bookingConfirmData?.detailsBookingViewModel?.charge +
                              bookingConfirmData?.detailsBookingViewModel?.vat,
                            0,
                            0,
                          )}
                          đ
                        </div>
                        <div>~</div>
                        <div>
                          $
                          {formatterUSD.format(
                            bookingConfirmData?.detailsBookingViewModel?.chargeUsd +
                              bookingConfirmData?.detailsBookingViewModel?.vatUsd,
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 6 */}
                  <div className="d-flex confirmation-page__booking-detail_table--border-bottom confirmation-page__booking-detail_table--ptb-18">
                    <div className="col-3 pl-0 payment-details__font-bold">{t('payment.label_paymentDetail')}</div>
                    <div className="col-9 pr-0">
                      <div className="d-flex justify-content-between">
                        <div>
                          <div>{t('payment.label_charges')}</div>
                          <div>{t('payment.label_VAT')}</div>
                          <div>{t('payment.label_totalPayable3')}</div>
                          <div className="payment-details__font-bold">{t('payment.label_localCurrency3')}</div>
                        </div>
                        <div>
                          <div className="d-flex justify-content-end">
                            {currentCurrency?.code === 'USD'
                              ? '$' + formatterUSD.format(bookingConfirmData?.detailsBookingViewModel?.chargeUsd)
                              : currentCurrency?.code === 'VND'
                              ? `${formatMoney(bookingConfirmData?.detailsBookingViewModel?.charge, 0, 0)}đ`
                              : ''}
                          </div>
                          <div className="d-flex justify-content-end">
                            {currentCurrency?.code === 'USD'
                              ? '$' + formatterUSD.format(bookingConfirmData?.detailsBookingViewModel?.vatUsd)
                              : currentCurrency?.code === 'VND'
                              ? `${formatMoney(bookingConfirmData?.detailsBookingViewModel?.vat, 0, 0)}đ`
                              : ''}
                          </div>
                          <div className="d-flex justify-content-end">
                            {currentCurrency?.code === 'USD'
                              ? '$' +
                                formatterUSD.format(
                                  bookingConfirmData?.detailsBookingViewModel?.chargeUsd +
                                    bookingConfirmData?.detailsBookingViewModel?.vatUsd,
                                )
                              : currentCurrency?.code === 'VND'
                              ? `${formatMoney(
                                  bookingConfirmData?.detailsBookingViewModel?.charge +
                                    bookingConfirmData?.detailsBookingViewModel?.vat,
                                  0,
                                  0,
                                )}đ`
                              : ''}
                            {currentCurrency?.code === 'USD' ? <span className="font-red">&nbsp;*</span> : ''}
                          </div>
                          <div className="d-flex justify-content-end">
                            {formatMoney(
                              bookingConfirmData?.detailsBookingViewModel?.charge +
                                bookingConfirmData?.detailsBookingViewModel?.vat,
                              0,
                              0,
                            )}
                            đ
                          </div>
                        </div>
                      </div>
                      <div className="font-red pt-3">{t('payment.label_localCurDes')}</div>
                    </div>
                  </div>

                  {/* 7 */}
                  <div className="d-flex confirmation-page__booking-detail_table--border-bottom confirmation-page__booking-detail_table--ptb-18">
                    <div className="col-3 pl-0 payment-details__font-bold">{t('payment.label_paymentTypeConfirm')}</div>
                    <div className="col-9 pr-0">
                      <div>{t('payment.label_youPaid')}</div>
                      <div className="font-red pt-3">{t('payment.label_NoteConfirm')}</div>
                    </div>
                  </div>

                  {/* 8 */}
                  {bookingConfirmData?.detailsApartment?.offerItems.length > 0 ? (
                    <div className="d-flex confirmation-page__booking-detail_table--border-bottom confirmation-page__booking-detail_table--ptb-18">
                      <div className="col-3 pl-0 payment-details__font-bold">{t('payment.label_offer')}</div>
                      <div className="col-9 pr-0">
                        {bookingConfirmData?.detailsApartment?.offerItems.map((item, index) => {
                          return (
                            <div key={index} className="d-flex justify-content-between">
                              <div className="d-flex align-items-center">
                                <img className="mr-1" src={GreenTick} alt="tick" />
                                {item.name}
                              </div>
                              <div className="font-green">{t('payment.label_free')}</div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}

                  {/* 9 */}
                  {bookingConfirmData?.detailsBookingViewModel?.specialRequirement !== '' ? (
                    <div className="d-flex confirmation-page__booking-detail_table--border-bottom confirmation-page__booking-detail_table--ptb-18">
                      <div className="col-3 pl-0 payment-details__font-bold">
                        {t('payment.label_specialRequirements')}
                      </div>
                      <div className="col-9 pr-0 text-break">
                        {bookingConfirmData?.detailsBookingViewModel?.specialRequirement}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}

                  {/* 10 */}
                  <div className="d-flex confirmation-page__booking-detail_table--ptb-18 pb-4 mb-2 confirmation-page__booking-detail_table--border-bottom">
                    <div className="col-3 pl-0 payment-details__font-bold">{t('payment.label_cancel')}</div>
                    <div className="col-9 pr-0">
                      <div className="pb-2">{t('payment.label_cancel_desc')}</div>
                      {equalCheckin === true ? (
                        <div className="d-flex">
                          <div className="pl-0 col-10">{t('payment.label_cancel3')}</div>
                          <div className="d-flex justify-content-end align-items-end font-red col-2">100%</div>
                        </div>
                      ) : (
                        <>
                          {/* {today <=
                          moment(
                            subDays(parseISO(moment(startDate).format('YYYY-MM-DD') + 'T13:59:59'), 7),
                          ).valueOf() ? (
                            <div className="d-flex pb-2">
                              <div className="pl-0 col-10">
                                {t('payment.label_cancel1', {
                                  date: handleDateLocale(
                                    subDays(
                                      moment(bookingConfirmData?.detailsBookingViewModel?.checkinDate).valueOf(),
                                      7,
                                    ),
                                  ),
                                })}
                              </div>
                              <div className="d-flex justify-content-end align-items-end font-red col-2">0%</div>
                            </div>
                          ) : (
                            ''
                          )} */}
                          <div className="d-flex pb-2">
                            <div className="pl-0 col-10">
                              {t('payment.label_cancel1', {
                                date: handleDateLocale(
                                  subDays(
                                    moment(bookingConfirmData?.detailsBookingViewModel?.checkinDate).valueOf(),
                                    2,
                                  ),
                                ),
                              })}
                            </div>
                            <div className="d-flex justify-content-end align-items-end font-red col-2">50%</div>
                          </div>
                          <div className="d-flex">
                            <div className="pl-0 col-10">
                              {t('payment.label_cancel2', {
                                date: handleDateLocale(
                                  subDays(
                                    moment(bookingConfirmData?.detailsBookingViewModel?.checkinDate).valueOf(),
                                    2,
                                  ),
                                ),
                              })}
                            </div>
                            <div className="d-flex justify-content-end align-items-end font-red col-2">100%</div>
                          </div>{' '}
                        </>
                      )}
                    </div>
                  </div>

                  <div className="d-flex confirmation-page__booking-detail_table--ptb-18 pb-4 mb-2">
                    <div className="font-red">{t('payment.label_notePassport')}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center button-confirm-page no-printme">
            {bookingStatus === 2 ? (
              <button onClick={() => setShowCancel(true)} className="button-confirm-page__back">
                {t('payment.label_cancelBooking')}
              </button>
            ) : (
              ''
            )}
            <input
              type="button"
              value={t('payment.label_goHome')}
              onClick={handleGoHome}
              className="button-confirm-page__continue"
            />
          </div>
          <CancelBookingComponent
            closeCancel={() => {
              getBooking(getQueryString({ language, bookingNumber })).then(res => {
                if (res) {
                  setBookingConfirmData(res);
                }
              });
              setShowCancel(false);
            }}
            showCancel={showCancel}
            bookingConfirmData={bookingConfirmData}
          />
        </div>
      </div>
      ) :
      (
        <><LoginComponent
            closeLogin={() => {
              setShowLogin(false);
            } }
            showLogin={showLogin}
            handleShowForgot={handleShowForgot}
            handleShowSignUp={handleShowSignUp} /><VerifyEmailComponent
              showVerifyEmail={showVerifyPopup}
              hideVerifyEmail={closeVerifyEmailPopup}
            ></VerifyEmailComponent><ForgotModal showModal={showForgot} hideModal={() => setShowForgot(false)} handleShowLogin={handleShowLogin} /></>
      )
      }
    </div>
  );
}

const mapStatetoProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStatetoProps, mapDispatchToProps)(StepThreeComponent);
